import { FC } from "react";
import type { DailyReferVM } from "@payping/api";
import { dayjs } from "@payping/utilities-shared/date";
import { Line, LineChart, Tooltip, XAxis, YAxis } from "recharts";
import { formatLocalizedNumber } from "@payping/utilities-shared/number";
import { useAppTranslation } from "@/utils";
import { Card, Flex, Typography } from "@payping/web-components";
interface Props {
  revenueValue?: DailyReferVM[];
}

const ReferralChart: FC<Props> = ({ revenueValue }) => {
  const { t } = useAppTranslation();
  const chartData = (revenueValue ?? []).map((i) => ({
    ...i,
    payDate: dayjs.utc(i?.payDate).toISOString(),
    amount: i.amount ?? 0,
  }));

  return (
    <>
      <div className="tw:relative">
        <LineChart style={{ aspectRatio: 2.5 }} responsive data={chartData}>
          <Line dataKey="amount" type="monotone" strokeWidth={2} />
          <XAxis
            padding={{ left: 12, right: 12 }}
            dataKey="payDate"
            type="category"
            tickFormatter={(value) => {
              return dayjs.utc(value).calendar("jalali").format("YYYY/MM/DD");
            }}
          />
          <YAxis
            padding={{ top: 12 }}
            direction={"ltr"}
            dataKey="amount"
            tickFormatter={(value) => formatLocalizedNumber({ value, options: { maximumFractionDigits: 2 } })}
          />
          <Tooltip
            content={(value) => {
              const amount = value?.payload[0]?.value;
              return (
                <Card size="small">
                  <Flex vertical>
                    <Typography.Text>{dayjs.utc(value?.label).calendar("jalali").format("YYYY/MM/DD")}</Typography.Text>
                    <Typography.Text>
                      <strong>
                        {`${formatLocalizedNumber({ value: Number(amount?.toString() ?? "0"), options: { maximumFractionDigits: 2 } })} ${t("common.tomans")}`}
                      </strong>
                    </Typography.Text>
                  </Flex>
                </Card>
              );
            }}
          />
        </LineChart>
      </div>
    </>
  );
};

export default ReferralChart;
